<div id="company-dashboard-tab" class="company-dashboard-tab">
    <div class="kpi-header">
        <h2>Absentismo</h2>
        <div class="date-pick">
            <mat-form-field>
                <input matInput [matDatepicker]="picker" [formControl]='datePickerControl'
                    (dateInput)="dateInputHandler()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <!-- Annual Table -->
    <div class="block-looper block-1">
        <h2>Anual</h2>
        <table mat-table [dataSource]="tablesService.tableData.annualTable">
            <caption></caption>
            <!-- Position Column -->
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> <span matTooltip="{{element.label}}">{{element.label}}</span>
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="cyear">
                <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear}} </th>
                <td mat-cell *matCellDef="let element"> <span>{{element.cyear}}</span> </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="pyear">
                <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear - 1}}
                </th>
                <td mat-cell *matCellDef="let element"> <span>{{element.pyear}}</span> </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="var">
                <th mat-header-cell *matHeaderCellDef class="var"> % Var. </th>
                <td mat-cell *matCellDef="let element"> <span>{{element.var}}</span> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tablesService.columnNames.fourColumnsTable; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: tablesService.columnNames.fourColumnsTable;"></tr>
        </table>
    </div>

    <!-- Mensual Table -->
    <div class="block-looper block-2">
        <h2>Mensual</h2>

        <!-- First Part -->
        <div class="block-looper-inner-half">
            <table mat-table [dataSource]="tablesService.tableData.mensualTable1">
                <caption></caption>
                <!-- Position Column -->
                <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <span
                            matTooltip="{{element.label}}">{{element.label}}</span> </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="cyear">
                    <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear}}
                    </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.cyear}}</span> </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="pyear">
                    <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear - 1}}
                    </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.pyear}}</span> </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="var">
                    <th mat-header-cell *matHeaderCellDef class="var"> % Var. </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.var}}</span> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tablesService.columnNames.fourColumnsTable; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: tablesService.columnNames.fourColumnsTable;"></tr>
            </table>
        </div>

        <!-- Second Part -->
        <div class="block-looper-inner-half">
            <table mat-table [dataSource]="tablesService.tableData.mensualTable2">
                <caption></caption>
                <!-- Position Column -->
                <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <span
                            matTooltip="{{element.label}}">{{element.label}}</span> </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="cyear">
                    <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear}}
                    </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.cyear}}</span> </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="pyear">
                    <th mat-header-cell *matHeaderCellDef class="year"> {{this.selectedMonth}} {{this.selectedYear - 1}}
                    </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.pyear}}</span> </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="var">
                    <th mat-header-cell *matHeaderCellDef class="var"> % Var. </th>
                    <td mat-cell *matCellDef="let element"> <span>{{element.var}}</span> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tablesService.columnNames.fourColumnsTable; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: tablesService.columnNames.fourColumnsTable;"></tr>
            </table>
        </div>
    </div>

    <!-- Diario Table -->
    <div class="block-looper block-3">
        <h2>Diario</h2>
        <table mat-table [dataSource]="tablesService.tableData.diarioTable">
           <caption></caption>
            <!-- Position Column -->
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> <span matTooltip="{{element.label}}">{{element.label}}</span>
                </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="fiels">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> <span>{{element.fiels}}</span> </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tablesService.columnNames.twoColumnsTable; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: tablesService.columnNames.twoColumnsTable;"></tr>
        </table>
    </div>

    <!-- Charts -->
    <div class="chart-view">
        <div class="half">
            <h3>Absentismo Diario</h3>
            <canvas baseChart [datasets]="chartsService.chartData.absentismoDiarioChart"
                [legend]="chartsService.chartProperties.showLegends" chartType="line"
                [labels]="chartsService.chartLabels.absentismoDiarioChartLabels"
                [options]="chartsService.chartProperties.chartOptions.percentageYAxis">
            </canvas>
        </div>

        <div class="half">
            <h3>Absnetismo Mensual</h3>
            <canvas baseChart [datasets]="chartsService.chartData.absentismoMensualChart"
                [labels]="chartsService.chartLabels.daysLabelsOfMonthlyCharts"
                [options]="chartsService.chartProperties.chartOptions.percentageYAxis"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Absentismo Comparativo</h3>
            <canvas baseChart [datasets]="chartsService.chartData.absentismoComparativoChart"
                [labels]="chartsService.chartLabels.allMonthsLabels"
                [options]="chartsService.chartProperties.chartOptions.percentageYAxis"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Absentismo Acumulado</h3>
            <canvas baseChart [datasets]="chartsService.chartData.absentismoAcumuladoChart"
                [labels]="chartsService.chartLabels.allMonthsLabels"
                [options]="chartsService.chartProperties.chartOptions.basic"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Bajas Nuevas</h3>
            <canvas baseChart [datasets]="chartsService.chartData.bajasNuevasChart"
                [labels]="chartsService.chartLabels.daysLabelsOfMonthlyCharts"
                [options]="chartsService.chartProperties.chartOptions.basic"
                [legend]="chartsService.chartProperties.showLegends" chartType="bar">
            </canvas>
        </div>

        <div class="half">
            <h3>Bajas nuevas comparativo</h3>
            <canvas baseChart [datasets]="chartsService.chartData.bajasNuevasComparativoChart"
                [labels]="chartsService.chartLabels.allMonthsLabels"
                [options]="chartsService.chartProperties.chartOptions.basic"
                [legend]="chartsService.chartProperties.showLegends" chartType="bar">
            </canvas>
        </div>

        <div class="half">
            <h3>Media bajas diarias</h3>
            <canvas baseChart [datasets]="chartsService.chartData.mediaBajasDiariasChart"
                [labels]="chartsService.chartLabels.daysLabelsOfMonthlyCharts"
                [options]="chartsService.chartProperties.chartOptions.floatingYAxis"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Plantilla</h3>
            <canvas baseChart [datasets]="chartsService.chartData.plantillaChart"
                [labels]="chartsService.chartLabels.daysLabelsOfMonthlyCharts"
                [options]="chartsService.chartProperties.chartOptions.basic"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Tasa de incidencia</h3>
            <canvas baseChart [datasets]="chartsService.chartData.tasaIncidenciaChart"
                [labels]="chartsService.chartLabels.allMonthsLabels"
                [options]="chartsService.chartProperties.chartOptions.percentageYAxis"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>

        <div class="half">
            <h3>Tasa de prevalencia</h3>
            <canvas baseChart [datasets]="chartsService.chartData.tasaPrevalenciaChart"
                [labels]="chartsService.chartLabels.allMonthsLabels"
                [options]="chartsService.chartProperties.chartOptions.percentageYAxis"
                [legend]="chartsService.chartProperties.showLegends" chartType="line">
            </canvas>
        </div>
    </div>
</div>